import React, { useCallback, useEffect, useRef, useState } from 'react'
import OptionsButtonCustom from '../../../../../components/option-button/OptionsButtonCustom'
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../../../components/button/ButtonCustoms'
import { MenuItem, Typography } from '@mui/material'
import { useParams } from 'react-router-dom';
import ModalCustom from '../../../../../components/modal/ModalCustom';
import InputTextField from '../../../../../components/input/inputTextField';
import { useTranslation } from 'react-i18next';
import { OnlineCourseApi } from '../../../../../api/cms-online-course/online_course.api';
import { alertActive, swalError, swalSuccess } from '../../../../../components/alert/swal';
import { setLoading, unsetLoading } from '../../../../../store/loading/loading.slice';
import { useDispatch } from 'react-redux';
import FilterSelect from '../../../../../components/select/filterSelect';
import { dateToView } from '../../../../../utils/date.utils';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CheckBoxCustom from '../../../../../components/checkbox/CheckBoxCustom';
import DatasetLinkedOutlinedIcon from '@mui/icons-material/DatasetLinkedOutlined';
const defaultState = {
    online_course_lesson_name: '',
}
const defaultStateTopic = {
    id_online_course_file_study_topics: undefined,
    online_course_study_topics_name: '',
    online_course_study_topics_desc: '',
}
export default function CourseLesson({ view }: any) {
    const { id } = useParams();
    const { t } = useTranslation();
    const fileRef = useRef<any>()
    const dispatch = useDispatch();
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [open, setOpen] = useState<boolean>(false);
    const [formTopic, setFormTopic] = useState<any>(defaultStateTopic)
    const [typeTopic, setTypeTopic] = useState<string>("CREATE");
    const [typeVideo, setTypeVideo] = useState<string>("FILE");
    const [openTopic, setOpenTopic] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const [dataTopic, setDataTopic] = useState<any[]>([]);
    const getLessonTopicData = async (id_online_course_lesson: any, id_online_course_study_topics: any) => {

        const res = await OnlineCourseApi.getLessonTopic(id, id_online_course_lesson, id_online_course_study_topics);
        const data = res.data
        setFormTopic({ ...data.data, online_course_file_study_topics: data.data.online_course_study_topics_file, id_online_course_file_study_topics: data.data.online_course_study_topics_file?.id_online_course_file })

        // set_file(data?.data);

    }
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            const res = await OnlineCourseApi.listLesson(id);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data);

                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);
    const loadDataTopic = useCallback(async () => {
        if (form?.id_online_course_lesson) {
            dispatch(setLoading());

            try {
                const res = await OnlineCourseApi.listLessonTopic(id, form?.id_online_course_lesson);
                const data = res.data
                if (data?.status < 300) {
                    setDataTopic(data?.data);

                    dispatch(unsetLoading());
                } else {
                    dispatch(unsetLoading());
                }
            } catch (error) {
                dispatch(unsetLoading());
            }
        }

    }, [form?.id_online_course_lesson]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    useEffect(() => {
        loadDataTopic();
    }, [loadDataTopic]);
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }
    const handleCreate = async () => {
        const body = {
            online_course_lesson_name: form?.online_course_lesson_name,

        };
        if (type === 'EDIT') {
            await OnlineCourseApi.patchLesson(body, id, form.id_online_course_lesson).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('บันทึกบทเรียน เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        } else {
            await OnlineCourseApi.postLesson(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('เพิ่มบทเรียน เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    const handleCloseTopic = async () => {
        setOpenTopic(false)
        setFormTopic(defaultStateTopic)
    }
    const handleCreateTopic = async () => {
        const body = {
            id_online_course_file_study_topics: formTopic?.id_online_course_file_study_topics,
            online_course_study_topics_name: formTopic?.online_course_study_topics_name,
            online_course_study_topics_desc: formTopic?.online_course_study_topics_desc,
            mark_as_example: formTopic?.mark_as_example,
            online_course_study_topics_link: formTopic?.online_course_study_topics_link,
        };
        if (typeTopic === 'EDIT') {
            await OnlineCourseApi.patchLessonTopic(body, id, form?.id_online_course_lesson, formTopic.id_online_course_study_topics).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('บันทึกหัวข้อการเรียน เรียบร้อยแล้ว'))
                    loadDataTopic()
                    handleCloseTopic()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        } else {
            await OnlineCourseApi.postLessonTopic(body, id, form?.id_online_course_lesson).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('เพิ่มหัวข้อการเรียน เรียบร้อยแล้ว'))
                    loadDataTopic()
                    handleCloseTopic()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);

            await OnlineCourseApi.fileTopics(formData).then((res: any) => {
                if (res.status < 300) {
                    setFormTopic({ ...formTopic, id_online_course_file_study_topics: res.data.data.id_online_course_file, online_course_file_study_topics: res.data.data })
                    console.log(res.data);

                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    const handleDelete = async (id_online_course_lesson: any) => {
        await OnlineCourseApi.deleteLesson(id, id_online_course_lesson).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })


    }
    const handleDeleteTopic = async (id_online_course_lesson: any, id_topic: any) => {
        await OnlineCourseApi.deleteTopic(id, id_online_course_lesson, id_topic).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
                loadDataTopic();
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })


    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <div className='w-full grid grid-cols-12 gap-4 mt-[40px]'>

            <div className='col-span-12 md:col-span-12 lg:col-span-6 border-2 rounded-lg border-[#4A4A4A] relative h-[480px]'>
                <div className="flex items-center justify-between gap-4 bg-[#4A4A4A] p-[20px] ">
                    <Typography sx={{ fontSize: '24px', fontWeight: '500', color: "#ffff" }}>บทเรียน</Typography>
                    {!view && <ButtonOutlined
                        onClick={() => {
                            // navigate(routeName.cms.AddAgenda.replace(':id', `${id}`))
                            setOpen(true)
                            setType('CREATE')
                            setForm(null)
                        }}
                        buttonName="เพิ่ม"
                        btnProps={{
                            width: "150px",
                        }}
                    />}
                </div>
                <div style={{ display: "flex", flexDirection: 'column', gap: '10px', padding: '10px' }}>
                    <div style={{ display: "flex", flexDirection: 'column', gap: '10px', height: '320px', overflowY: 'auto' }}>

                        {data?.map((item: any) => {
                            return (
                                <div style={{
                                    border: '1px solid  #F2F4F7',
                                    padding: '16px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    boxShadow: '0px 0px 7px -2px #1018281A'
                                }} onClick={() => { setForm(item) }}>
                                    {item?.online_course_lesson_name}
                                    <OptionsButtonCustom
                                        enableView
                                        enableEdit={!view}
                                        enableDelete={!view}

                                        onViewClick={() => {
                                            setOpen(true)
                                            setType('VIEW')
                                        }}

                                        onEditClick={() => {
                                            setOpen(true)
                                            setType('EDIT')
                                        }}
                                        onDeleteClick={() => {
                                            alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                                handleDelete(item?.id_online_course_lesson)
                                            })
                                        }} />
                                </div>
                            )
                        })}
                    </div>
                </div>

            </div>

            <div className='col-span-12 md:col-span-12 lg:col-span-6 border-2 rounded-lg border-[#737373] relative h-[480px]'>
                <div className="flex items-center justify-between gap-4 bg-[#737373] p-[20px] ">
                    <Typography sx={{ fontSize: '24px', fontWeight: '500', color: "#ffff" }}>หัวข้อการเรียน</Typography>

                    {(!view && form?.id_online_course_lesson) && <ButtonOutlined
                        onClick={() => {
                            setOpenTopic(true)
                            setTypeTopic('CREATE')
                            setTypeVideo('FILE')
                        }}
                        buttonName="เพิ่ม"
                        btnProps={{
                            width: "150px",
                        }}
                    />}
                </div>
                <div style={{ display: "flex", flexDirection: 'column', gap: '10px', padding: '10px' }}>
                    <Typography>{form?.online_course_lesson_name}</Typography>
                    <div style={{ display: "flex", flexDirection: 'column', gap: '10px', height: '320px', overflowY: 'auto' }}>
                        {form?.id_online_course_lesson && dataTopic?.map((item: any) => {
                            return (
                                <div style={{
                                    border: '1px solid  #F2F4F7',
                                    padding: '16px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    boxShadow: '0px 0px 7px -2px #1018281A'

                                }}>
                                    {item?.online_course_study_topics_name}
                                    <OptionsButtonCustom
                                        enableView
                                        enableEdit={!view}
                                        enableDelete={!view}

                                        onViewClick={() => {
                                            setOpenTopic(true)
                                            setTypeTopic('VIEW')
                                            setTypeVideo(item?.online_course_study_topics_link ? 'LINK' : "FILE")
                                            // setFormTopic(item)
                                            getLessonTopicData(item?.id_online_course_lesson, item?.id_online_course_study_topics)
                                        }}

                                        onEditClick={() => {
                                            setOpenTopic(true)
                                            setTypeTopic('EDIT')
                                            setTypeVideo(item?.online_course_study_topics_link ? 'LINK' : "FILE")
                                            // setFormTopic(item)
                                            getLessonTopicData(item?.id_online_course_lesson, item?.id_online_course_study_topics)

                                            // navigate(
                                            //     routeName.cms.MeetingCaledarDetail.replace(':id', id_meeting_room)
                                            // );
                                            // navigate(routeName.cms.AddSubAgenda.replace(':id', `${id}`).replace(':idAgenda', `${item?.id_meeting_agenda_ref}`) + `?id=${item?.id_meeting_agenda}`)
                                        }}

                                        onDeleteClick={() => {
                                            alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                                handleDeleteTopic(item?.id_online_course_lesson, item?.id_online_course_study_topics)
                                            })
                                        }}
                                    />
                                </div>
                            )
                        })}
                    </div>

                </div>
            </div>
            <ModalCustom title={type === 'CREATE' ? t('เพิ่มบทเรียน') : t('ข้อมูลบทเรียน')} subTitle={t('กรุณาระบุรายละเอียด')} open={open} component={
                <div className='flex flex-col gap-4'>


                    <div>
                        <InputTextField
                            heading={t("ชื่อบทเรียน")}
                            placeholder={t("ระบุ")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, online_course_lesson_name: e.target.value })
                            }}
                            value={form?.online_course_lesson_name || ''}
                            required
                        />
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreate()
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />}
                    </div>
                </div>
            } />
            <ModalCustom title={typeTopic === 'CREATE' ? t('เพิ่มหัวข้อการเรียน') : t('ข้อมูลหัวข้อการเรียน')} subTitle={t('กรุณาระบุรายละเอียด')} open={openTopic} component={
                <div className='flex flex-col gap-4'>
                    <CheckBoxCustom label='ตั้งค่าเป็นตัวอย่าง' checked={formTopic?.mark_as_example || false} setChecked={(e) => {
                        setFormTopic({ ...formTopic, mark_as_example: e })

                    }} />
                    <div>
                        <FilterSelect
                            value={form?.id_online_course_lesson || ""}
                            heading={t('อยู่ภายใต้บทเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={data.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_lesson} key={index + 1}>
                                    {item.online_course_lesson_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // setFormTopic({ ...formTopic, id_online_course_lesson: e.target.value })
                            }}
                            disabled={false}
                        />
                    </div>

                    <div>
                        <InputTextField
                            heading={t("ชื่อหัวข้อการเรียน *")}
                            placeholder={t("ระบุ")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setFormTopic({ ...formTopic, online_course_study_topics_name: e.target.value })
                            }}
                            value={formTopic.online_course_study_topics_name || ''}
                            required
                        />
                    </div>
                    <div className='col-span-12 md:col-span-12  border-2 rounded-lg border-[#DDE1EB] relative h-auto my-[20px]'>
                        {typeVideo === 'FILE' && <>

                            <div className="flex items-center gap-4 p-[10px] ">
                                <AddBoxIcon sx={{ color: '#0F9F0C', cursor: 'pointer' }} onClick={() => fileRef.current.click()} />
                                <DatasetLinkedOutlinedIcon sx={{ color: typeVideo === 'FILE' ? '#7e7e7e' : '#0F9F0C', cursor: 'pointer' }} onClick={() => {
                                    setTypeVideo('LINK')
                                    setFormTopic({ ...formTopic, online_course_file_study_topics: null, id_online_course_file_study_topics: null })

                                }} />
                                <input ref={fileRef} className='hidden' type='file' accept={"video/*"} onChange={(e: any) => onImageChange(e)} />

                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>ไฟล์วีดีโอ</Typography>


                            </div>
                            {formTopic?.online_course_file_study_topics &&
                                <div className='flex items-center justify-between p-[20px]'>
                                    <div>
                                        <Typography>{formTopic?.online_course_file_study_topics?.file_name}</Typography>
                                        <Typography>{formatBytes(formTopic?.online_course_file_study_topics?.file_size)} {formTopic?.online_course_file_study_topics?.created_date ? dateToView(formTopic?.online_course_file_cover?.created_date) : '-'}</Typography>

                                    </div>
                                    <OptionsButtonCustom
                                        enableView
                                        enableDelete
                                        onViewClick={() => {
                                            window.open(`${process.env.REACT_APP_FILE_BASE_API}/${formTopic?.online_course_file_study_topics?.file_path}${formTopic?.online_course_file_study_topics?.file_name}`)
                                        }}


                                        onDeleteClick={() => {
                                            setFormTopic({ ...formTopic, id_online_course_file_study_topics: undefined, online_course_file_study_topics: undefined })

                                        }} />
                                </div>}
                        </>}
                        {typeVideo === 'LINK' && <>

                            <div className="flex items-center gap-4 p-[10px] ">
                                <AddBoxIcon sx={{ color: typeVideo === 'LINK' ? '#7e7e7e' : '#0F9F0C', cursor: 'pointer' }} onClick={() => {
                                    setTypeVideo('FILE')
                                    setFormTopic({ ...formTopic, online_course_study_topics_link: '' })

                                }} />
                                <DatasetLinkedOutlinedIcon sx={{ color: '#0F9F0C', cursor: 'pointer' }} onClick={() => setTypeVideo('LINK')} />
                                <input ref={fileRef} className='hidden' type='file' accept={"video/*"} onChange={(e: any) => onImageChange(e)} />

                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>ลิงก์วิดีโอ</Typography>


                            </div>
                            <div style={{ padding: '15px' }}><InputTextField placeholder={t("ระบุ")}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    // handleChangeValueSearch("leave_type_name", e.target.value);
                                    setFormTopic({ ...formTopic, online_course_study_topics_link: e.target.value })
                                }}
                                value={formTopic.online_course_study_topics_link || ''} /></div></>}
                    </div>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleCloseTopic()
                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {typeTopic !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreateTopic()
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
